import React from "react";
import * as Styled from "./SelectTemplate.styled";
import { getLayoutImage, LayoutImages, LayoutTemplates } from "../../../libs";
import AdPreviewImage from "../../../assets/images/layout/AdPreviewImage_01.png";
import { Image } from "react-bootstrap";

export const SelectTemplate: React.FC<{
    selectedTemplate: LayoutTemplates;
    excludeTemplates?: LayoutTemplates[];
    changed?: boolean;
    onBack: () => void;
    onTemplateSelect: (templateId: LayoutTemplates) => void;
}> = ({ selectedTemplate, excludeTemplates, onBack, onTemplateSelect, changed = false }) => {

    return (
        <Styled.OrderSelectionWrapper>

            <Styled.LeftSection>
                <Styled.OrderSelectionRow>
                    <Styled.OrderSelectionCol>
                        <Styled.OrderSelectionHeader>
                            <Styled.OrderSelectionHeaderText>
                                Select template
                            </Styled.OrderSelectionHeaderText>
                        </Styled.OrderSelectionHeader>
                    </Styled.OrderSelectionCol>
                </Styled.OrderSelectionRow>
                <Styled.OrderSelectionRow className="mt-4">
                    <Styled.OrderSelectionCol >
                        <Styled.LayoutCardContainer>
                            <Styled.LayoutGrid>
                                {Object.entries(LayoutImages).map(([key, _]) => {
                                    const templateId = Number(key);
                                    if (excludeTemplates?.includes(templateId)) return null;
                                    return (
                                        <Styled.LayoutCard
                                            key={templateId}
                                            selected={selectedTemplate === templateId}
                                            changed={changed}
                                            onClick={() => onTemplateSelect(templateId)}
                                        >
                                            <Image src={getLayoutImage(templateId)} width={150} />
                                        </Styled.LayoutCard>
                                    );
                                })}
                            </Styled.LayoutGrid>
                        </Styled.LayoutCardContainer>
                    </Styled.OrderSelectionCol>
                </Styled.OrderSelectionRow>
            </Styled.LeftSection>

            <Styled.RightSection>
                <Styled.PreviewWrapper>
                    <Styled.PreviewHeader>Preview</Styled.PreviewHeader>
                    <Image src={AdPreviewImage} width={500} />
                </Styled.PreviewWrapper>
            </Styled.RightSection>

        </Styled.OrderSelectionWrapper>
    );
};
